export const AI_MARKETER_ANALYTICS_EVENT = 'AI Marketer LP CTA Clicked';

export const AI_MARKETING_PAGE_PATH = '/ai-marketing';

export const FREE_COURSE_KEY = 'cd15914';
export const FREE_COURSE_SLUG = 'automate-marketing-workflows-with-ai--cd15914';

export const START_LEARNING_PROGRAM_KEYS = ['nd018', 'nd028'] as const;

export const STAY_UP_TO_DATE_SECTION_ID = 'stay-up-to-date';
export const STAY_POSTED_EMAIL_INPUT_ID = 'stay-posted-email';
export const STAY_POSTED_LEAD_FORM_LABEL = 'AI Marketer LP';
export const START_LEARNING_SECTION_ID = 'start-learning';

export const YOUTUBE_VIDEO_ID = 'mnE3FLIdCi0';

export const COMING_SOON_PROGRAM = {
  title: 'AI Marketer Nanodegree',
  summary:
    'Optimize for AI search with GEO and AEO, run synthetic persona research, forecast CPC and LTV, and build autonomous marketing agents.',
} as const;

export const COPY = {
  hero: {
    title: 'Become an AI Marketer.\nStart for free.',
    description:
      'Our AI Marketer Nanodegree program is coming soon. Get a head start with a free hands-on course that makes AI do the work, not just help with it.',
    startFreeCourse: 'Start free course',
    joinWaitlist: 'Join the waitlist',
  },
  freeCourse: {
    eyebrow: 'free course',
    title: 'Automate marketing workflows with AI',
    description:
      "Stop prompting from scratch. In five hands-on modules, you'll build a reusable Claude Skills library with Brand Voice, Product Accuracy, and Platform Standards and turn it into a scheduled workflow that runs marketing operations automatically.",
    whatYoullBuild: "What you'll build:",
    bullets: [
      "A custom Skills library built from your brand's knowledge",
      'A scheduled marketing routine that runs automatically',
      'A reusable system you can expand as your marketing needs grow',
    ],
    footnote: '(Bring your own Claude account.)',
    enroll: 'Enroll for Free',
  },
  stats: {
    subtitle: 'WHY NOW',
    heading: 'The AI shift is already underway',
  },
  whyUdacity: {
    subtitle: 'WHY UDACITY',
    title: "Learn AI Marketing from the platform that's trained 25M+ in AI",
    description:
      'Udacity has trained 25M+ learners in AI, machine learning, and data science. That same practitioner-first depth is now purpose-built for marketers. No technical background required.',
  },
  testimonials: {
    subtitle: 'What learners say',
    title: 'Real skills. Real outcomes.',
  },
  startLearning: {
    title: 'Start learning today',
    description:
      'From marketing fundamentals to autonomous AI systems — structured programs for working practitioners.',
    comingSoonLabel: 'Coming soon',
    notifyMe: 'Notify Me',
  },
  video: {
    title: "AI made it easier to be good. Here's how to be great.",
  },
  stayPosted: {
    title: 'Marketing moves even faster now. Stay up to date.',
    description:
      'Be the first to know about new courses, exclusive promotional offers, upcoming live practitioner webinars, and original research on how AI is reshaping marketing.',
    emailLabel: 'Email address',
    emailPlaceholder: 'Your email',
    submit: 'Keep me posted',
    interestToastTitle: "We're collecting interest",
    interestToastDescription: 'Thanks for your interest in the AI Marketer program.',
  },
} as const;

export const STAT_ITEMS = [
  {
    value: '87',
    suffix: '%',
    color: 'blue.700',
    dividerRgb: '123, 162, 255',
    description: 'of marketers are concerned about technology, including GenAI, replacing jobs in their industry.',
    source: 1,
  },
  {
    value: '56',
    suffix: '%',
    color: 'blue.500',
    dividerRgb: '123, 162, 255',
    description: "wage premium for workers who have AI skills vs. those who don't.",
    source: 2,
  },
  {
    value: '2x',
    color: 'purple.500',
    dividerRgb: '229, 165, 255',
    description: 'AI-driven automation of marketing work expected to more than double from 16% in 2026 to 36% by 2028.',
    source: 3,
  },
] as const;

export const STAT_SOURCES = [
  {
    source: 1,
    label: 'Gartner, 2024',
    href: 'https://www.gartner.com/',
  },
  {
    source: 2,
    label: 'PwC Global AI Jobs Barometer, 2025',
    href: 'https://www.pwc.com/gx/en/services/ai/ai-jobs-barometer.html',
  },
  {
    source: 3,
    label: 'Gartner CMO Survey, 2026',
    href: 'https://www.gartner.com/',
  },
] as const;
